import React from "react";
import { ShieldCheckIcon } from "lucide-react";
export function Footer() {
  return <footer className="w-full bg-gray-900 px-4 py-10 text-center" data-id="element-110" data-mp="3gezf99jl213s">
      <div className="mx-auto max-w-lg" data-id="element-111" data-mp="3ghc486nrdbqc">
        <div className="mb-3 inline-flex items-center gap-2" data-id="element-112" data-mp="32onigxc1ze6b">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[var(--brand)]" data-id="element-113" data-mp="32m1d94cmxar9">
            <ShieldCheckIcon className="h-4 w-4 text-white" data-id="element-114" data-mp="36n3c3k2n3ksp" />
          </span>
          <span className="font-serif-display text-base font-bold text-white" data-id="element-115" data-mp="3uftlpmn2lrzt">
            Clínica Segura<span className="align-super text-[10px]" data-id="element-116" data-mp="387fpncvpdfs">™</span>
          </span>
        </div>
        <p className="text-xs leading-relaxed text-gray-400" data-id="element-117" data-mp="3ldu5gwjvqrxx">
          © 2026 · Dra. Karito – Protocolo Clínica Segura™
          <br data-id="element-118" data-mp="3qfjgwdb0l7mj" />
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}